export { default as FeaturedAndSortedPortalsCardList } from './featured-and-sorted-portals-card-list';
